import React from "react";
import { Link } from "react-router-dom";

function RateCalculator(props) {
  const { amount, sendToCountry, sendFromCountry, exchange } = props;
  const { total, currency } = amount;
  const { defaultCurrency } = sendToCountry[0];
  const defaultCurrencyVal = defaultCurrency[0];

  let fees = 0;
  let feesCurrency = sendFromCountry[0]["currency"][0];
  let baseRate = exchange[defaultCurrencyVal];
  let payoutAmount =
    defaultCurrencyVal === currency
      ? total
      : (total * parseFloat(exchange[defaultCurrencyVal])).toFixed(2);
  let calculatedTotal =
    defaultCurrencyVal === currency
      ? (total / parseFloat(exchange[defaultCurrencyVal])).toFixed(2)
      : total;
  return (
    <>
      <div className="w-100 d-flex flex-column align-items-center text-dark mt-3 pt-3 pb-5">
        <div className="d-flex align-items-center justify-content-center mb-3 py-2 ">
          <p className="mb-0 ls-1">
            Fees: {fees} {feesCurrency}
          </p>
          <div
            className="mx-3 bg-dark"
            style={{ width: "1px", height: "40px" }}
          ></div>
          <p className="mb-0 ls-1">
            Total: {calculatedTotal}
            {feesCurrency}
          </p>
        </div>
        <div className="mb-2">
          <h5 className="fs-22 ls-1">
            Payout Amount: {payoutAmount} {defaultCurrencyVal}
          </h5>
        </div>
        <div>
          <p className="mb-0 ls-1">
            (Exchange Rate 1 GBP - {baseRate} {defaultCurrencyVal})
          </p>
        </div>
        <div className="w-100 d-flex justify-content-center mt-4 mb-14 pb-5">
          <Link
            to="/"
            className="btn btn-dark btn-dark-hoverable p-3 rounded-pill width-160"
          >
            Send
          </Link>
        </div>
      </div>
    </>
  );
}

export default RateCalculator;
